import {Helper} from "@nolimitcity/promo-panel/bin/utils/Helper";
import {WINTYPE} from "@nolimitcity/promo-panel/bin/enums/ASEnums";
import {
    ActionSpinOptions,
    ActionSpinSound,
    ASWinData,
    PromoPanelGameConfiguration
} from "@nolimitcity/promo-panel/bin/interfaces/ASInterfaces";
import {FITHGameAssets} from "./FITHGameAssets";
import {FITHGameModuleConfig} from "./FITHGameModuleConfig";
import {FITHSoundConfig} from "./FITHSoundConfig";
import {FITHSoundManager} from "./sound/FITHSoundManager";
import {FITHGameMode} from "./gameMode/FITHGameMode";
import {FreespinIntroController} from "@nolimitcity/slot-game/bin/game/screen/freespinintro/FreespinIntroController";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {FITHAvalancheReelController} from "./reel/FITHAvalancheReelController";
import {FireInTheHole} from "./FireInTheHole";
import {FITHParsedGameData} from "./server/data/FITHParsedGameData";


export class FITHPromoPanelConfig implements PromoPanelGameConfiguration{
    private wasFeatureBuy:boolean = false;
    constructor() {
    }

    public getActionSpinOptions(): ActionSpinOptions {
        return {
            gameName: "Mental",
            hasActionSpin: true,
            graphics: {backgroundTextureName: "introBg"},
            getParsedData: (response: any, bet: number, prevResponse: any):ASWinData => {
                if (response.wasFeatureBuy == true){
                    this.wasFeatureBuy = response.wasFeatureBuy
                } else {
                    if (response.mode == "NORMAL" || response.nextMode == "NORMAL"){
                        this.wasFeatureBuy = false;
                    }
                }

                const parsedData: ASWinData = {
                    totalWin: this.getTotalWin(response, bet, prevResponse),
                    wasFeatureBuy: response.wasFeatureBuy,
                    freeSpinTriggeredThisSpin: response.freespinTriggeredThisSpin,
                    totalSpinWinnings: this.getSpinWin(response),
                    isBigWin: this.isBigWin(response),
                    winType: response.mode === FITHGameMode.BONUS ? WINTYPE.MULTIPLIER : WINTYPE.NORMAL,
                    featureName: this.getFeatureName(response),
                    isRoundComplete: this.isRoundComplete(response),
                    isBonusEnd: this.isBonusEnd(response),
                    isWinCapHit: response.brokeTheBank,

                }
                return parsedData;
            }
        };
    }

    private getTotalWin(response: any, bet: number, prevData: any): number {
        if (response.mode == FITHGameMode.BONUS && response.nextMode == FITHGameMode.BONUS){
            return response.bonusWinTimesBetAfter * response.playedBetValue;
        }
        else {
            return response.accumulatedRoundWin;
        }
    }

    private getSpinWin(response: any): number {
        if (response.mode == FITHGameMode.BONUS ){
            //This should return the actual timesBet value, not the calculated money win.
            return response.bonusWinTimesBetAfter - response.bonusWinTimesBetBefore;
        }
        else {
            return response.totalAvalancheRoundWinnings;
        }
    }


    private isBigWin(response:any): boolean {
        //https://github.com/nolimitcity/fireinthehole/issues/375 below condition only meant for this issue
        if(response.brokeTheBank){
            return true;
        }
        
        if (response.mode == FITHGameMode.BONUS){
            let win = (response.bonusWinTimesBetAfter - response.bonusWinTimesBetBefore);
            if (this.wasFeatureBuy){
                win*=response.playedBetValue;
                const betPrice = FITHGameModuleConfig.featurePrice.getFeaturePrice();
                let winRatio: number = Helper.ceilToDecimals((win / betPrice), 2);
                return winRatio >= 1;
            } else {
                return win >= 15;
            }
        }


        let win = response.totalAvalancheRoundWinnings;
        let winRatio: number = Helper.ceilToDecimals((win / response.playedBetValue), 2);
        return winRatio >= 15;
    }

    private getFeatureName(response: any): string {

        if ((response.mode == FITHGameMode.BONUS) || response.nextMode ==  FITHGameMode.BONUS){
            return "LUCKY WAGON SPINS";
        }
        return response.mode;
    }

    private isRoundComplete(response: any): boolean {
        return ([FITHGameMode.BONUS, FITHGameMode.NORMAL].indexOf(response.nextMode) > -1);
    }

    private isBonusEnd(response: any): boolean {
        return (response.mode === FITHGameMode.BONUS) && (response.nextMode === FITHGameMode.NORMAL);
    }

    public onActionSpinPlaySound(trigger:ActionSpinSound):void {
        if (trigger == ActionSpinSound.WIN){
            FITHSoundManager.playSoundEffect(FITHSoundConfig.AS_WIN);
        }
        else if (trigger == ActionSpinSound.BIG_WIN) {
            FITHSoundManager.playSoundEffect(FITHSoundConfig.AS_WIN_BIG);
        }
    }

    onPlayBonusInGame(data:any):void {
        this.restoreBaseGameReels(data);
        EventHandler.dispatchEvent(new GameEvent(ServerEvent.GAME_DATA_RECEIVED, data));
        FITHGameModuleConfig.reelFrameView.moveBarrierForAS((data.baseActiveRowsAfter - 3));

        EventHandler.dispatchEvent(new GameEvent(ScreenEvent.GAME_START));
        FireInTheHole.keypad.setWin(data.accumulatedRoundWin, true, FITHGameModuleConfig.featurePrice.isWinBelowStake());
    }


    private restoreBaseGameReels(data:any): void {
        const reels: string[][] = data.reelsEnteringFreespin;
        let sym: StateReelSymbol;
        for (let i: number = 0; i < reels.length; i++) {
            for (let j: number = 0; j < reels.length; j++) {
                sym = (Reels.getSymbol(i, j)!);
                sym.replaceWith(reels[i][j], i);
                if (sym.symName === "X") {
                    sym.setVisibility(false);
                }
            }
            (Reels.getReel(i) as FITHAvalancheReelController).reOrderSymbols();
        }
    }


}